export enum NettingEngineSummary {
    ISDA_NO = 'Close out netting is not enforceable',
    ISDA_MAYBE = 'Close out netting might be enforceable',
    ISDA_YES = 'Close out netting is enforceable',
    ISDA_YES_PRODUCTS_UNKNOWN = 'Close out netting is enforceable depending on selected transaction types',
    GMRA_YES_PRODUCTS_UNKNOWN_AND_YES = 'Close out netting is enforceable depending on selected transaction types, the method of collaterisation is enforceable',
    GMRA_YES_AND_YES = 'Close out and collaterisation structure is robust',
    GMRA_YES_AND_NO = 'Close out netting is enforceable but the method of collaterisation is not',
    GMRA_NO_AND_YES = 'Close out netting is not enforceable but the method of collaterisation is enforceable',
    GMRA_NO_AND_NO = 'Neither close out netting nor method of collaterisation are enforceable',
    GMRA_MAYBE_AND_MAYBE = 'Close out netting might be enforceable and collaterisation might be enforceable',
    GMRA_YES_AND_MAYBE = 'Close out netting is enforceable but the method of collaterisation might be enforceable',
    GMRA_MAYBE_AND_YES = 'Close out netting might be enforceable but the method of collaterisation is enforceable',
    GMRA_NO_AND_MAYBE = 'Close out netting is not enforceable but the method of collaterisation might be enforceable',
    GMRA_MAYBE_AND_NO = 'Close out netting might be enforceable but the method of collaterisation is not'
}

export enum CloseOutNettingSummary {
    YES = 'Close out netting is enforceable',
    YES_PRODUCTS_UNKNOWN = 'Close out netting is enforceable depending on selected transaction types',
    NO = 'Close out netting is not enforceable',
    MAYBE = 'Close out netting might be enforceable'
}

export enum CollateralisationMethodSummary {
    YES = 'Collateralising exposure is enforceable',
    NO = 'Collateralising exposure is not enforceable',
    MAYBE = 'Collateralising exposure might be enforceable'
}
